/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Settings_Hints_DescriptionInputs */



/**
* | output |
* | --- |
* | "Show small Uno hint icons next to features that explain them in context. Requires Uno to be enabled." |
*
* @param {Uno_Settings_Hints_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_settings_hints_description = /** @type {((inputs?: Uno_Settings_Hints_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Settings_Hints_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kleine Uno-Hinweissymbole neben Funktionen anzeigen, die diese im Kontext erklären. Erfordert einen aktivierten Uno.")
	return /** @type {LocalizedString} */ ("Show small Uno hint icons next to features that explain them in context. Requires Uno to be enabled.")
});